import React, { useState } from "react";
import axios from "axios";
import {
  Progress,
  Box,
  ButtonGroup,
  Button,
  Heading,
  Flex,
  FormControl,
  GridItem,
  FormLabel,
  HStack,
  Input,
  Select,
  SimpleGrid,
  InputLeftAddon,
  InputGroup,
  Textarea,
  FormHelperText,
  InputRightElement,
  Checkbox,
  CheckboxGroup,
} from "@chakra-ui/react";

import { useToast } from "@chakra-ui/react";
import { Description } from "@mui/icons-material";

const Form5 = (props) => {
  const [name, setName] = useState("");
  const [title, setTitle] = useState("");
  const [location, setLocation] = useState("");
  const [desc, setDesc] = useState("");
  const [start, setStart] = useState(new Date());
  const [end, setEnd] = useState(new Date());
  const [isWorking, setIsWorking] = useState(false);

  const handleNext = () => {
    const formData = {
      organisation:name,
      title:title,
      location:location,
      tenure:{
        start:start,
        end:end
      },
      description:desc,
      current:isWorking
    };
    axios.post('https://glb-api.onrender.com/student/form5', {formData:formData}, {withCredentials : true })
    .then(res => {
      console.log("sent successfully" + JSON.stringify(formData));
    })
    .catch(err => {
      console.log(err);
    })
    // props.onNext();
  };

  const handleBack = () => {
    // Handle form submission
    // ...
    // Call the OnBack callback from props to update the step state
    props.OnBack();
  };
  return (
    <>
    <Box m={50}>
      <Heading
        w="100%"
        textAlign={'center'}
        fontSize="5xl"
        mb="4%"
      >
        Add New Responsibility/Job
      </Heading>
      <SimpleGrid columns={1} spacing={6}>
        <Flex>
        <FormControl mr="5%" >
          <FormLabel htmlFor="middle-name">Enter Comapany Name</FormLabel>
          <Input id="Score"  placeholder="Search Company Name" borderColor="transparent" boxShadow="md" value={name}
              onChange={(e) => {
                setName(e.target.value);
              }}/>
          </FormControl>

          {/* <FormControl mr="5%" size="sm">
            <Select
              id="type"
              name="type"
              autoComplete="type"
              placeholder="Search Company Sector"
              color="gray.400"
              focusBorderColor="brand.400"
              shadow="sm"
              size="sm"
              w="full"
              rounded="md"
            >
              <option>Full Time</option>
              <option>Private</option>
            </Select>
          </FormControl> */}
        </Flex>
        <FormControl mr="5%" >
          <Flex>
          <FormControl mr="5%" >
            <FormLabel htmlFor="middle-name">Job Title</FormLabel>
              <Input id="Score"  placeholder="Enter Job Title" borderColor="transparent" boxShadow="md"  value={title}
              onChange={(e) => {
                setTitle(e.target.value);
              }}/>
            </FormControl>

            <FormControl mr="5%" >
            <FormLabel htmlFor="middle-name">Job Location</FormLabel>
              <Input id="Score"  placeholder="Enter Job Location" borderColor="transparent" boxShadow="md"  value={location}
              onChange={(e) => {
                setLocation(e.target.value);
              }}/>
            </FormControl>
          </Flex>
        </FormControl>
        <FormControl mr="5%" size="sm">
          {/* <Flex> */}
            {/* <FormControl mr="5%" size="sm">
              <Select
              id="type"
              name="type"
              autoComplete="type"
              placeholder="Select Position Type"
              color="gray.400"
              focusBorderColor="brand.400"
              shadow="sm"
              size="sm"
              w="full"
              rounded="md"
              mt={5}
            >
              <option>Full Time</option>
              <option>Private</option>
            </Select>
            </FormControl> */}

            {/* <FormControl mr="5%" size="sm">
              <Select
              id="type"
              name="type"
              autoComplete="type"
              placeholder="Select Job Function"
              color="gray.400"
              focusBorderColor="brand.400"
              shadow="sm"
              size="sm"
              w="full"
              rounded="md"
              mt={5}
            >
              <option>Full Time</option>
              <option>Private</option>
            </Select>
            </FormControl>
          </Flex> */}
        </FormControl>
        <FormControl mr="5%" >
        <FormLabel mt={5}>
            Select Start Date and End Date
            </FormLabel>
          <Flex>
            <FormControl mr="5%" >
              <Input id="Start"  placeholder="Select Start Date" type="date" borderColor="transparent" boxShadow="md" value={start}
              onChange={(e) => {
                setStart(e.target.value);
              }}/>
            </FormControl>

            <FormControl mr="5%" size="sm">
              <Input id="End"  placeholder="Select End Date"  type="date" borderColor="transparent" boxShadow="md" value={end}
              onChange={(e) => {
                setEnd(e.target.value);
              }}/>
            </FormControl>
          </Flex>
        </FormControl>

        {/* <FormControl mr="5%" size="sm">
          <Flex>
            <FormControl mr="5%" size="sm">
              <Select
              id="type"
              name="type"
              autoComplete="type"
              placeholder="Select Salary/Stipend Range"
              color="gray.400"
              focusBorderColor="brand.400"
              shadow="sm"
              size="sm"
              w="full"
              rounded="md"
              mt={5}
            >
              <option>Full Time</option>
              <option>Private</option>
            </Select>
            </FormControl> */}

<FormControl mr="5%" size="sm">
              <Checkbox value={isWorking} borderWidth= "2px"
        borderColor= "black"
              onChange={(e) => {
                setIsWorking(!isWorking);
                console.log(isWorking);
              }} default="checked" fontSize="md" size="sm" mt={8}  > I currently work here
              </Checkbox>
            </FormControl>
          {/* </Flex>
        </FormControl> */}
        <FormControl width={'md'}  >
          <FormLabel  >
            Description
          </FormLabel>
          <InputGroup size="md">
          <Textarea resize="none" borderColor="transparent" boxShadow="md" placeholder='description'
            value={desc}
            onChange={(e) => {
              setDesc(e.target.value);
            }}  />

          </InputGroup>
        </FormControl>
      </SimpleGrid>
      {/* <Button
          w="7rem"
          height="3rem"
          fontSize="2md"

          onClick={handleNext}
          colorScheme="blue"
          variant="outline"
        >
          Next
        </Button>

        <Button
          w="7rem"
          height="3rem"
          fontSize="2md"

          onClick={handleBack}
          colorScheme="blue"
          variant="outline"
        >
          back
        </Button> */}
        <Button mt="40px" colorScheme="blue" onClick={handleNext}>
          Submit
        </Button>
      </Box>
    </>

  );
};

export default Form5;
